import { render } from "./customerreport.vue?vue&type=template&id=5737d361"
import script from "./customerreport.vue?vue&type=script&lang=js"
export * from "./customerreport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__